import React from 'react';

export default function StatCounter({ value, className = '' }) {
  return <span className={className}>{value}</span>;
}
